import { request, getHeaders } from "./axios";

export const createUser = async (data = {}) => {
  return request({
    url: "/admin/onboard",
    method: "POST",
    data,
    headers: await getHeaders(),
  });
};
